import { payableAmountSelector } from '@/features/purchase/purchaseSelectors';
import useLocalizedCurrencyFormatter from '@/hooks/useLocalizedCurrencyFormatter';
import { useSelector } from '@/store/utils';

// The change-booking checkout's "Change total" = the BE-provided amount
// still to be paid (`payableAmount`), formatted as an absolute currency.
// This is the post-credit figure (reused payment, change fees, vouchers
// already netted out), not the raw `exchangePrice` delta used on the
// offer-page preview footer. Renders '-' until the value is available.
export const useChangeTotal = (): string => {
  const payableAmount = useSelector(payableAmountSelector);
  const numberFormatter = useLocalizedCurrencyFormatter();
  return payableAmount === null ? '-' : numberFormatter.format(payableAmount);
};
